import * as React from 'react';
import { Route, RouteProps } from 'react-router-dom';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';

import { emitter } from '@app/Services/EventEmitter';
import { Forbidden } from '@app/Pages/Forbidden/Forbidden';

@observer
export class EdwRoute extends React.Component<RouteProps> {
    private _store: EdwRouteStore = new EdwRouteStore();

    componentDidUpdate(prevProps: RouteProps) {
        if (prevProps.path !== this.props.path) {
            this._store.clearError();
        }
    }

    componentWillUnmount() {
        this._store.unload();
    }

    render() {
        if (this._store.hasError) {
            return <Forbidden />;
        }

        return <Route {...this.props} />;
    }
}

class EdwRouteStore {
    @observable hasError: boolean = false;

    constructor() {
        emitter.on('notify-error-403', this._onErrorHandler);
    }

    unload() {
        emitter.off('notify-error-403', this._onErrorHandler);
    }

    @action.bound
    private _onErrorHandler() {
        this.hasError = true;
    }

    @action
    clearError() {
        this.hasError = false;
    }
}
